document.addEventListener("DOMContentLoaded", function () {

    const params = new URLSearchParams(window.location.search);

    if (params.get("source") !== "businesscard") return;

    const popup = document.getElementById("itc-business-card-popup");

    if (popup) {
        popup.style.display = "flex";
    }

    hideShopifyFormsTeaser();

});

function hideShopifyFormsTeaser() {

    const teaser = document.querySelector('button[data-testid="form-teaser"]');

    if (teaser) {
        teaser.style.display = "none";
    }

}

function showShopifyFormsTeaser() {

    const teaser = document.querySelector('button[data-testid="form-teaser"]');

    if (teaser) {
        teaser.style.display = "";
    }

}

function itcCopyCoupon() {

    navigator.clipboard.writeText("FIRSTITC10");

    const btn = document.getElementById("itc-copy-button");

    btn.innerHTML = "✓ Coupon copied!";

    btn.disabled = true;

    setTimeout(function () {

        btn.innerHTML = "Copy Coupon";

        btn.disabled = false;

    }, 2000);

}

function itcClosePopup() {

    const popup = document.getElementById("itc-business-card-popup");

    popup.style.display = "none";

    showShopifyFormsTeaser();

}